/* eslint-disable */
import { extendDecorator } from '@/js/common/Domain/Service/mixins/decorators';

import CommentsRepository from '@/js/common/Domain/Repository/Comments';
import gaAsync from '@/js/common/Domain/Service/gaAsync';
import Comment from '@/js/common/Domain/Factory/Comment';
import OurReview from './OurReview';
import ReviewModel from './OurReviewModel';
import ReviewForm from './reviewsForm/ReviewForm';

@extendDecorator({
    events: {
        'click .js-add-review': 'openReviewForm',
        'click .js-open-review-form': 'openReviewForm',
        'click .hotelMoreReviewsButton': 'nextPage',
    },
    itemView: OurReview,
    loadingRequest: null,
    bindings: {
        '.hotelReviewsWrapperLive': 'collection:$collection, toggle:numOfComments',
        '.hotelReviewsWrapperStatic': 'toggle:false',
        '.hotelReviewsTopPanel': 'toggle:numOfComments',
        '.hotelReviewsNoComments': "toggle:all(not(numOfComments), equal(loadingState, 'finished'))",
        '.js-open-review-form': "toggle:all(numOfComments, equal(loadingState, 'finished'))",
        '.hotelMoreReviewsButton': "toggle:all(nextPageAvailable, not(equal(loadingState, 'loading')))",
        '.hotelMoreReviewsButton span': 'text:commentsLeftText',
        '.openReviewForm': "toggle:not(showAddCommentForm), event:['click', 'toggleCommentForm']",
        '.closeReviewForm': "toggle:showAddCommentForm, event:['click', 'toggleCommentForm']",
        '.js-reviews-loading': "toggle: equal(loadingState, 'loading')",
        '.addReview': 'animatedToggle:showAddCommentForm',
    },
})
export default class OurReviewsList extends Backbone.Epoxy.View {
    initialize() {
        this.model = new ReviewModel();
        this.collection = new CommentsRepository();

        this.initSortSelect();

        this.reviewForm = new ReviewForm();
        this.initEvents();
    }

    openReviewForm() {
        this.reviewForm.openReviewForm();
    }

    load() {
        if (this.model.get('loadingState') === 'notLoaded') {
            this.loadData();
        }
    }

    initSortSelect() {
        const self = this;
        $('.reviewsSortingOrder', this.el).select2({minimumResultsForSearch: Infinity}).on('change', function () {
            const sortCriteria =  $(this).val();
            self.model.set('sortCriteria', sortCriteria);
        });
    }

    toggleCommentForm() {
        const showAddCommentForm = this.model.get('showAddCommentForm');
        this.model.set('showAddCommentForm', !showAddCommentForm);

        if (!showAddCommentForm) {
            gaAsync(() => {
                ga('send', 'event', 'Buttons', 'Add_a_review', window.appConfig.hotelInfo.name, {nonInteraction: 1});
            });
        }
    }

    initEvents() {
        this.model.on('change:pageNumber', this.loadData.bind(this));
        this.model.on('change:sortCriteria', this.clearAndLoad.bind(this));
    }

    nextPage() {
        const pageIncAvailable = this.model.get('nextPageAvailable');
        const currentPage = this.model.get('pageNumber');

        if (pageIncAvailable) {
            this.model.set('pageNumber', currentPage + 1);
        }

        gaAsync(() => {
            ga('send', 'event', 'Buttons', 'Show_more_reviews', window.appConfig.hotelInfo.name, {nonInteraction: 1});
        });
    }

    clearAndLoad() {
        this.clearData();
        this.loadData();
    }

    clearData() {
        this.model.set('clearData', true);
        this.model.set('pageNumber', 1);
    }

    loadData() {
        const hotelId = window.appConfig.hotelInfo.id;
        const page = this.model.get('pageNumber');
        const limit = this.model.get('limit');
        const sort = this.model.get('sortCriteria');


        if (this.loadingRequest) {
            this.loadingRequest.abort();
        }
        this.model.set('loadingState', 'loading');

        this.loadingRequest = $.get(`${window.appConfig.gatewayUrl}/apiV1/hotel/getReviews`, {
            hotelId,
            limit,
            page,
            sort,
        });

        this.loadingRequest.done((response) => {
            if (response?.success && response?.data?.feedbacksCount) {
                this.model.set('numOfComments', response.data.feedbacksCount);

                const comments = _.map(response.data.feedbacks, feedback => new Comment({
                    ..._.pick(feedback, 'id', 'user', 'mealRate', 'locationRate', 'serviceRate', ''),
                    text: feedback.text || 'Пользователь поставил только оценку, без текста',
                    dataSource: null,
                    hotel: {},
                    rate: (feedback.rate ** 0) === feedback.rate ? parseInt(feedback.rate, 10) : parseFloat(feedback.rate).toFixed(1),
                    created: feedback.createdDate,
                    status: 'accepted',
                }));

                if (this.model.get('clearData')) {
                    this.collection.reset(comments);
                } else {
                    this.collection.add(comments);
                }
            }
        });

        this.loadingRequest.always(() => {
            this.model.set('loadingState', 'finished');
            this.model.set('clearData', false);
        });
    }
}